import { render, staticRenderFns } from "./airCultureReport.vue?vue&type=template&id=649477b5&scoped=true&"
import script from "./airCultureReport.vue?vue&type=script&lang=js&"
export * from "./airCultureReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649477b5",
  null
  
)

export default component.exports